<template>
  <div>
    <el-row>
      <el-col :span="12" align="left"><label style="width: 150px;"><b>ID:</b></label>{{selectDevice.device_id.substring(7)}}</el-col>
      <el-col :span="12" align="left"><label style="width: 150px"><b>Fireware Version:</b></label>{{selectDevice.device_fireware_version}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="12" align="left"><label style="width: 150px"><b>Bluetooth Version:</b></label>{{selectDevice.device_bluetooth_version}}</el-col>
      <el-col :span="12" align="left"><label style="width: 150px"><b>Audio Version:</b></label>{{selectDevice.device_audio_version}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="12" align="left"><label style="width: 150px"><b>Login Log:</b></label> {{this.total}} logs</el-col>
      <el-col :span="12" align="left"><a @click="$emit('showlog')" style="width: 150px;color:#409EFF;">Download Device_Log</a></el-col>
    </el-row>
    <el-row>
      <el-table :data="loginLog" empty-text="No record!" height="300px" border stripe>
        <el-table-column label="Login Datetime">
          <template slot-scope="scope">
            {{new Date(scope.row.device_login_datetime*1000)}}
          </template>
        </el-table-column>
        <el-table-column prop="device_login_ip" label="Login IP"></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col align="right">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row align="right">
      <el-col align="right">
      <el-button size="small" @click="$emit('close')">back</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'DeviceDetail',
    props: {
      chooseItem: Object,
      close: Function,
      showlog:Function
    },
    data () {
      return {
        
        selectDevice: null,
        loginLog: [],
        total: 0,
        pageSize: 20,
        currentPage: 1
      }
    },
    created () {
      this.selectDevice = JSON.parse(JSON.stringify(this.chooseItem))
      this.getData()
    },
    methods: {
      getData () {
        let loading = this.$util.loading()
        this.$api.rootV1.post('/web/deviceloginlog', {
            device_id: this.chooseItem.device_id,
            page: this.currentPage,
            size: this.pageSize
          },
          (res) => {
            if (res.data.length !== 0) {
              this.loginLog = res.data
              this.total = res.totalCount
            }
            loading.close()
          }, () => {
            loading.close()
          })
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.getData()
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/device/DeviceDetail.vue